import React from 'react'
import {
    Visa,
    Mastercard,
    Discover,
    AmericanExpress,
    Paypal,
    ApplePay,
    GooglePay,
    AccreditedBusiness,
} from '../../../CustomSVGs/PaymentIcons'

const CartFlyoutPaymentIcons = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                paddingBottom: '3rem',
            }}
        >
            <span style={{ fontWeight: 500, paddingBottom: '8px' }}>
                Secure checkout with:
            </span>
            <div
                style={{
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'center',
                    paddingBottom: '15px',
                }}
            >
                <Visa />
                <Mastercard />
                <Discover />
                <AmericanExpress />
            </div>
            {/*<div
                style={{
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '8px',
                    marginBottom: '24px',
                }}
            >
                <Paypal />
                <ApplePay />
                <GooglePay />
            </div>*/}
            <AccreditedBusiness />
        </div>
    )
}

export default CartFlyoutPaymentIcons
